import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Rebate } from '../../../../classes/Rebate';
import { GlobalService } from '../../../services/global.service';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';

@Component({
  selector: 'app-rebate',
  templateUrl: './rebate.component.html',
  styleUrls: ['./rebate.component.scss']
})
export class RebateComponent implements OnInit {

  id: number;
  contentVisible: boolean = false;
  rebateData: Rebate = new Rebate( );

  availableRoles: string[] = [ 'admin', 'installer' ];
  isAvailable: boolean = true;

  constructor ( 
    private route: ActivatedRoute, 
    private model: ModelService,
    private global: GlobalService,
    private loginService: LoginService ) { 
    this.global.setDocumentTitle( 'Rebate/Incentive Details' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
  }

  ngOnInit ( ) {
    this.route.params.subscribe(params => {
       this.id = +params['id'];
       this.model.getRebateDataByID( this.id, ( rebate ) => {
         this.contentVisible = true;
         this.rebateData = rebate;
       });
    });
  }
}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/rebates/rebate/rebate.component.ts